import { CompanyKeyFigureGraphs } from 'components/common/KeyFigureGraph/CompanyKeyFigureGraphs';
import t from 'utils/translations';
import { Card, CardBody } from 'components/common/Card';
import { Table } from 'antd';
import {
    buildCategoryTabDataSource,
    customExpandIcon,
    GroupCompanyTableColumns,
    GroupTableInfo
} from 'components/CommonGroupAndCategoryStuff/GroupsTableHelpers';
import * as React from 'react';
import { GroupsByCategories, KeyFigureData } from 'components/context/types';
import {
    CompanyTablePagination,
    CompanyTableSortField
} from 'components/CommonGroupAndCategoryStuff/CompanyTable';
import { PaginationProps } from 'antd/es/pagination';
import { ColumnProps, SorterResult } from 'antd/es/table';

export interface CategoryContentProps {
    companyTablePagination: CompanyTablePagination;
    setCompanyTablePagination: (pagination: CompanyTablePagination) => void;
    deleteCompanyFromGroup: (groupId: string, businessId: string) => void;
    expandRow: (expanded: any, record: any) => void;
    fetchCategory: () => void;
    graphData: KeyFigureData;
    groupsByCategory: GroupsByCategories;
    groupsTableData: GroupTableInfo[];
    isGraphDataLoading: boolean;
    isTableDataLoading: boolean;
    setActiveTab: (activeTab: string) => void;
}
export default function CategoryTabContent({
    companyTablePagination,
    setCompanyTablePagination,
    deleteCompanyFromGroup,
    expandRow,
    fetchCategory,
    graphData,
    groupsByCategory,
    groupsTableData,
    isGraphDataLoading,
    isTableDataLoading,
    setActiveTab
}: CategoryContentProps) {
    return (
        <>
            <CompanyKeyFigureGraphs
                canCompare={true}
                isAggregateData={true}
                showMonths={false}
                isLoading={isGraphDataLoading}
                keyFigureData={graphData}
                title={t('GROUPS_KEYFIGURES')}
            />
            <Card>
                <CardBody>
                    <Table
                        columns={GroupCompanyTableColumns}
                        dataSource={buildCategoryTabDataSource(
                            groupsTableData,
                            [groupsByCategory],
                            fetchCategory,
                            deleteCompanyFromGroup,
                            setActiveTab
                        )}
                        expandIcon={iconProps => customExpandIcon(iconProps)}
                        indentSize={50}
                        loading={isTableDataLoading}
                        onChange={(
                            pagination: PaginationProps,
                            filters: any,
                            sorter: SorterResult<ColumnProps<any>>
                        ) => {
                            setCompanyTablePagination({
                                ...companyTablePagination,
                                sortField: sorter.order
                                    ? (sorter.field as CompanyTableSortField)
                                    : CompanyTableSortField.Name,
                                sortOrder:
                                    sorter.order === 'descend' ? 'DESC' : 'ASC'
                            });
                        }}
                        onExpand={(expanded, record) =>
                            expandRow(expanded, record)
                        }
                        pagination={false}
                    />
                </CardBody>
            </Card>
        </>
    );
}
